'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

const SegmentConsentContext = createContext<string[] | null>(null);

export const SegmentConsentProvider = ({
  consentOverride,
  children,
}: PropsWithChildren<{ consentOverride: string[] | null }>) => (
  <SegmentConsentContext.Provider value={consentOverride}>
    {children}
  </SegmentConsentContext.Provider>
);

export const useConsentOverride = () => useContext(SegmentConsentContext);
